import script from "./breadcrumb.vue?vue&type=script&setup=true&lang=js"
export * from "./breadcrumb.vue?vue&type=script&setup=true&lang=js"

import "./breadcrumb.vue?vue&type=style&index=0&id=9e6850a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e6850a0"]])

export default __exports__